import React,{Children,Fragment,cloneElement,isValidElement} from 'react';
import Pagination,{usePagination} from './Pagination';

function flatten(children,prefix='') {
  return Children.toArray(children).flatMap((child,index)=>{
    if(!isValidElement(child))return [];
    const key=`${prefix}/${child.key??index}`;
    return child.type===Fragment?flatten(child.props.children,key):[cloneElement(child,{key})];
  });
}

function text(children) {
  return Children.toArray(children).map(child=>typeof child==='string'||typeof child==='number'?String(child):isValidElement(child)?text(child.props.children):'').join(' ');
}

// Presentation-only paging: keep editors mounted so changing pages never loses
// draft input/selection. All rows are restored by print CSS; exports use source data.
export default function PaginatedTable({children,pagination:remote,paginationLabel='Rows',pageSize=10,paginationKey='',...props}) {
  const sections=Children.toArray(children);
  const bodies=sections.filter(child=>isValidElement(child)&&child.type==='tbody');
  const allRows=bodies.flatMap(body=>flatten(body.props.children));
  const placeholder=allRows.length===1&&Children.toArray(allRows[0].props.children).filter(isValidElement).length===1&&
    Children.toArray(allRows[0].props.children).some(cell=>isValidElement(cell)&&Number(cell.props.colSpan)>1);
  const identity=allRows.map(row=>[row.key,Children.toArray(row.props.children).filter(isValidElement).slice(0,2).map(cell=>text(cell.props.children))]);
  const local=usePagination(placeholder?0:allRows.length,JSON.stringify([paginationKey,identity]),pageSize);
  const p=remote||local;
  let offset=0;
  return <div className="erp-paginated-table">
    <table {...props} aria-busy={p.loading||undefined} onInvalidCapture={event=>{
      props.onInvalidCapture?.(event);
      const row=event.target.closest('tr[data-pagination-row]');
      if(row&&!remote){p.setPage(Math.floor(Number(row.dataset.paginationRow)/p.size)+1);requestAnimationFrame(()=>event.target.focus());}
    }}>
      {sections.map(section=>{
        if(!isValidElement(section)||section.type!=='tbody')return section;
        const rows=flatten(section.props.children);
        return cloneElement(section,{},rows.map(row=>{
          const index=offset++;
          return cloneElement(row,{'data-pagination-row':index,hidden:!remote&&!placeholder&&(index<p.start||index>=p.end),className:`${row.props.className||''} erp-paginated-row`});
        }));
      })}
    </table>
    <Pagination pagination={p} label={paginationLabel}/>
  </div>;
}
